// extracted by mini-css-extract-plugin
module.exports = {"departments":"dj","departmentHeading":"ej","departmentSection":"fj","departmentName":"gj","departmentLink":"hj","expandIcon":"ij"};